import React, { FC } from 'react'

import { Loader } from '@/components/Loader'

import { EmptyPlayerElem } from './styles'

export const ChannelLoadingItem: FC = () => {
  return (
    <EmptyPlayerElem>
      <Loader />
    </EmptyPlayerElem>
  )
}
